import React from 'react'
import Cards from '../Cards';
import { useLocation } from 'react-router-dom';

const SupportUsers = () => {
  const pathprop = useLocation().pathname.slice(1);
  console.log(pathprop)
  
  return(
      <Cards pathValue ={pathprop} />
  )
}

export default SupportUsers